import { render, staticRenderFns } from "./onHeho.vue?vue&type=template&id=39f917eb&scoped=true"
import script from "./onHeho.vue?vue&type=script&lang=js"
export * from "./onHeho.vue?vue&type=script&lang=js"
import style0 from "./onHeho.vue?vue&type=style&index=0&id=39f917eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f917eb",
  null
  
)

export default component.exports